import http from '../httpService';

export function createSpniftForm(payload) {
  return http.post('/spnift-forms',payload);
}
export function getAllSpniftClientAcceptabilities() {
  return http.get('/spnift-client-acceptabilities');
}
export function editSpniftForm(id,payload) {
  return http.put(`/spnift-forms/${id}`,payload)
}

export function createLegalForm(payload) {
  return http.post('/legal-forms',payload);
}

export function editLegalForm(id,payload) {
  return http.put(`/legal-forms/${id}`,payload);
}
export function getAllLegalClientAcceptabilities() {
  return http.get('/legal-client-acceptabilities');
}
export function createComplianceForm(payload) {
  return http.post('/compliance-forms',payload);
}

export function editComplianceForm(id,payload) {
  return http.put(`/compliance-forms/${id}`,payload);
}
export function getAllComplianceRiskLevels() {
  return http.get('/compliance-risk-levels');
}
export function getSpniftForm(cycleId) {
  return http.get(`/spnift-forms?cycleId.equals=${cycleId}`)
}

export function getLegalForm(cycleId) {
  return http.get(`/legal-forms?cycleId.equals=${cycleId}`)
}

export function getComplianceForm(cycleId) {
  return http.get(`/compliance-forms?cycleId.equals=${cycleId}`)
}